import React from 'react';
import {PhaseElem} from './PhaseGraph.jsx'
import { MuiIcon } from "../../common/Icons.jsx";
import Turbolink from "../../common/Turbolink.jsx";

import { monitoring_report_show_path } from '~/routes';

const PhaseNumberExplanation = ({phase}) => {
    const NODE_SIZE = 8;
    const viewBoxHeight = NODE_SIZE * 2;
    const viewBoxWidth = NODE_SIZE * 14;
    return (
        <div style={{display: 'flex'}}>
            <div style={{flexBasis: '33.3%', textAlign: 'center'}}>
                <svg viewBox={`0 0 ${ viewBoxWidth / 4 } ${ viewBoxHeight }`} style={{width: '100%' , height: viewBoxHeight * 6}}>
                    <PhaseElem 
                        phase={{body:{}, type: phase.type}} 
                        selected={ true }
                        x={0.25} 
                        y={0} 
                        size={NODE_SIZE}
                        onMouseEnter={() => {}}
                        onMouseLeave={() => {}}
                        onClick={() => {}}
                        isWidget={ true }
                        scale={1}
                        isKey={ true }
                    />
                </svg>
            </div>
            <div style={{flexBasis: '66.6%'}}>
                {phase.description.map((d, i) => <p key={i}><strong>{ d.title + ": " }</strong>{ d.explanation }</p>)}
            </div>
        </div>
    )
}

const WorkFlowStatusKey = ({monitoringReportId}) => {
    const phases = [
        {
            type: 'fill', 
            description: [
                {title: I18n.t('widget_key_in_draft'), explanation: I18n.t('in_draft_explanation')},
                {title: I18n.t('widget_key_rejected'), explanation: I18n.t('reverted_explanation')}
            ]
        },
        {
            type: 'commenting', 
            description: [
                {title: I18n.t('widget_key_in_review'), explanation: I18n.t('in_review_explanation')},
                {title: I18n.t('widget_key_blocked'), explanation: I18n.t('pending_explanation')}
            ]
        },
        {
            type: 'approval', 
            description: [
                {title: I18n.t('widget_key_pending_approval'), explanation: I18n.t('pending_approval_explanation')},
                {title: I18n.t('widget_key_approved'), explanation: I18n.t('approved_explanation')}
            ]
        },

    ]
    return (
    <div>
        {phases.map((p) => <PhaseNumberExplanation key={p.type} phase = {p} />)}
        <span><MuiIcon type="new_releases" style={{color: 'red'}} /> {I18n.t('workflow_status_widget_key_warning_explanation')}</span>
        <div className='mt-1'>
            <Turbolink
                href={monitoring_report_show_path({
                    id: monitoringReportId, 
                    _options: true
                })}
            >
                {I18n.t("adjust_review_queue_time")}
            </Turbolink>
        </div>
    </div>
    )}

export default WorkFlowStatusKey;